import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadFileDirective } from './upload-file.directive';
import { UploadImageDirective } from './upload-image.directive';
import { UploadContainerComponent } from './upload-container/upload-container.component';
import { MatIconModule } from '@angular/material';
export class HdUploadModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        MatIconModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [UploadFileDirective, UploadImageDirective, UploadContainerComponent],
    declarations: [UploadFileDirective, UploadImageDirective, UploadContainerComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HdUploadModule_tsickle_Closure_declarations() {
/** @type {?} */
HdUploadModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HdUploadModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
